import { CardSkeleton } from '../../molecules/card/cardAnalytic/CardSkeleton';

export const DashboardMetricLoader = () => (
  <div className='flex items-center gap-24'>
    {[1, 2, 3, 4].map((index) => (
      <CardSkeleton key={index} />
    ))}
  </div>
);
